var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circular-progress__outer-circle rounded-circle mx-1",class:{ small: _vm.size === 'small', medium: _vm.size === 'medium', large: _vm.size === 'large' },style:({'--progress': _vm.degreesCounter + 'deg', '--textBgColor': _vm.textBgColor, '--textColor': _vm.textColor}),attrs:{"data-progress":_vm.valueCounter > _vm.value ? _vm.value : _vm.valueCounter}},[_c('div',{class:{ 
            small: _vm.size === 'small', 
            medium: _vm.size === 'medium', 
            large: _vm.size === 'large',
            'circular-progress__inner-circle rounded-circle' : true,
            'show-percentage' : _vm.showPercentageValue
        },attrs:{"data-progress":_vm.valueCounter > _vm.value ? _vm.value : _vm.valueCounter}},[(!_vm.showPercentageValue)?_vm._t("default"):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }